import { type ReactNode } from 'react';

import { ZgriPermissionGuard } from './zgri-permission.guard';

const ZGRI_LANDLORD_FEATURE_PERMISSION = 'user.zgri.use-landlord-features' as const;

type ZgriFeatureGuardProps = {
  children: ReactNode;
  redirectTo?: string;
};

export function ZgriFeatureGuard({ children, redirectTo }: ZgriFeatureGuardProps) {
  if (redirectTo) {
    return (
      <ZgriPermissionGuard
        require={ZGRI_LANDLORD_FEATURE_PERMISSION}
        variant="redirect"
        redirectTo={redirectTo}
      >
        {children}
      </ZgriPermissionGuard>
    );
  }

  return (
    <ZgriPermissionGuard require={ZGRI_LANDLORD_FEATURE_PERMISSION}>{children}</ZgriPermissionGuard>
  );
}
